import DrammenKommuneIcon from "./drammenKommuneIcon";
export default DrammenKommuneIcon;
